import { translate } from "@/i18n/messages.js";
import { shareTikTokMap } from "@/services/tiktokShare.js";

function localShareUrl(map) {
  const token = String(map?.shareCode || map?.id || "").trim();
  const url = new URL(window.location.href);
  url.pathname = `${import.meta.env.BASE_URL || "/"}workshop/shared/${encodeURIComponent(token)}`.replace(/\/+/g, "/");
  url.search = "";
  url.hash = "";
  return url.toString();
}

export async function shareCustomMap(map) {
  if (!map) throw new Error("Map not found.");

  const shareCode = String(map?.shareCode || "").trim();
  const url = map.shareUrl || localShareUrl(map);
  const title = map.name || "BricksBeater Map";
  const text = translate(document.documentElement.lang || "en", "shareInviteText");

  const tiktokResult = await shareTikTokMap({
    shareCode,
    title,
    subtitle: text,
    imageUrl: map.imageDataUrl || map.imageUrl || map.image || ""
  });

  if (tiktokResult) {
    return {
      ...tiktokResult,
      url,
      backendReady: Boolean(map.shareUrl || shareCode)
    };
  }

  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return { mode: "native", url, backendReady: Boolean(map.shareUrl || shareCode) };
    } catch (error) {
      if (error?.name === "AbortError") {
        return { mode: "cancelled", url, backendReady: Boolean(map.shareUrl || shareCode) };
      }
    }
  }

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
    return { mode: "clipboard", url, backendReady: Boolean(map.shareUrl || shareCode) };
  }

  return { mode: "manual", url, backendReady: Boolean(map.shareUrl || shareCode) };
}
